import { useParams } from 'react-router-dom';
import { UserForm } from '@/components/user-form/UserForm';

const UserFormPage = () => {
  const { userId } = useParams<{ userId: string }>();

  return <UserForm userId={userId} />;
};

export default UserFormPage;